import myhead from './Myhead/index'
import mybottom from './Mybottom/index'
import mytips from './Mytips/index'

export default {
  myhead,
  mybottom,
  mytips
}



//////////////////
// WEBPACK FOOTER
// ./src/components/myCom.js
// module id = null
// module chunks = 